// File: frontend/src/config/seo.js

const BASE_URL = process.env.REACT_APP_APP_URL || 'https://allegoryinsurance.com';

export const SEO_CONFIG = {
  home: {
    title: 'Home',
    description: 'Your Smart Digital Insurance Wallet. Manage all your insurance policies in one secure place with AI-powered insights.',
    canonical: BASE_URL,
    image: `${BASE_URL}/images/og-home.png`,
    noindex: false,
  },
  about: {
    title: 'About Us',
    description: 'We\'re not an insurance company, we\'re your advocate. Learn how Allegory helps you understand and optimize your insurance policies.',
    canonical: `${BASE_URL}/about`,
    image: `${BASE_URL}/images/og-about.png`,
    noindex: false,
  },
  contact: {
    title: 'Contact Us',
    description: 'Get in touch with Allegory Insurance. We\'re here to help with your policy questions and account support.',
    canonical: `${BASE_URL}/contact`,
    image: `${BASE_URL}/images/og-contact.jpg`,
    noindex: false,
  },
  pricing: {
    title: 'Pricing',
    description: 'Simple, transparent pricing for your digital insurance wallet. Start free, upgrade anytime. No hidden fees.',
    canonical: `${BASE_URL}/pricing`,
    image: `${BASE_URL}/images/og-pricing.png`,
    noindex: false,
  },
  products: {
    title: 'Insurance Products',
    description: 'Explore all insurance types supported by Allegory - Auto, Home, Life, Health, Travel, Pet, Commercial, and Pension insurance.',
    canonical: `${BASE_URL}/products`,
    image: `${BASE_URL}/images/og-products.png`,
    noindex: false,
  },
  privacy: {
    title: 'Privacy Policy',
    description: 'How Allegory Insurance protects and handles your personal information. Your data security is our priority.',
    canonical: `${BASE_URL}/privacy-policy`,
    image: `${BASE_URL}/images/og-default.png`,
    noindex: false,
  },
  terms: {
    title: 'Terms of Service',
    description: 'Terms and conditions for using Allegory Insurance services. Read our user agreement and service terms.',
    canonical: `${BASE_URL}/terms-of-service`,
    image: `${BASE_URL}/images/og-default.png`,
    noindex: false,
  },
  smsTerms: {
    title: 'SMS Terms of Service | Allegory Insurance',
    description: 'SMS Terms of Service for Allegory Insurance OTP verification program. Learn about message frequency, how to opt out, and how we protect your data.',
    canonical: `${BASE_URL}/sms-terms`,
    image: `${BASE_URL}/images/og-default.png`,
    noindex: false,
  },
  notFound: {
    title: '404 - Page Not Found',
    description: 'The page you\'re looking for doesn\'t exist. Return to Allegory Insurance homepage.',
    canonical: `${BASE_URL}/404`,
    image: `${BASE_URL}/images/og-default.png`,
    noindex: true,
  },
};